import  '../common/js/_include';

// ------------------------------
// modaal
// ------------------------------
$(() => {
  $('[class*="js-modal-"]').each((i, e) => {
    const modalOptions = {
      animation_speed: 200
    }

    // インラインテキストで使うときに使用する
    const accessibilityInlineAdd = function () {
      modalOptions.before_open = (event) => {
        // モーダルの見出しと内容にid付与
        $('.js-modal-inline').each((i, elem) => {
          const $target = $(elem);
          const id = $target.attr('href');
          const modal_id = $target.data('modaalScope');
          const title_id = `${modal_id}_title`;

          // それぞれのインラインテキストモーダルにh2がある時id付与
          // ※h2以外のタイトルの場合は変更して使う
          const title = $(id).find('h2');


          if (title.length > 0) {
            title.attr('id', title_id);
          }
        });
      };

      modalOptions.after_open = (event) => {
        // aria-modal,aria-labelledbyを付与する
        const title_id = `${$(event).attr('id')}_title`;
        $(event).find('.modaal-focus').attr({ 'aria-modal': true, 'aria-labelledby': title_id });
      };
    }

    const $e = $(e)
    if ($e.hasClass('js-modal-youtube')) {
      if (!$e.attr('href')) {
        $e.attr('href', `https://www.youtube-nocookie.com/embed/${$e.attr('data-youtube')}?autoplay=1&mute=1&rel=0`)
      }
      modalOptions.type = 'video'
    }
    if ($e.hasClass('js-modal-img')) {
      modalOptions.type = 'image'
    }
    if ($e.hasClass('js-modal-inline')) {
      modalOptions.type = 'inline';
      accessibilityInlineAdd();
    }
    if ($e.hasClass('js-modal-start')) {
      modalOptions.start_open = true
    }
    $e.modaal(modalOptions)
  })
})


// ------------------------------
// select2
// ------------------------------
$(() => {
  $('.js-select').select2({
    width:'100%',
    minimumResultsForSearch: -1
  });
})

// ------------------------------
// slick
// ------------------------------
$(() => {
  const $slide = $('.js-product-slide')
  if ($slide.length <= 0) {
    return false;
  }
  for (const slide of $slide) {
      $(slide).slick({
        arrows:false,
        dots: true,
        //autoplay:$(slide).find('img').length > 1 ? true : false,
        autoplay:false
        //speed: 200,
      });

      // slick-dotsの要素移動
      $(slide).after($(slide).find('.slick-dots'));

      // クローンのdata-group属性外す
      $(slide).find('.slick-cloned a').removeAttr('data-group');
  }
});

$(function() {

  $('.js-contents[data-tab="2"]').addClass('active').show();
  $('.js-tab[data-tab="2"]').addClass('active');
  $('.js-tab').on('click', function() {
    var tabId = $(this).data('tab');
    if ($(this).hasClass('active')) {
      return;
    }
    $('.js-tab').each(function() {
      var offImg = $(this).find('.nav__number img');
      offImg.attr('src', offImg.attr('src').replace('-on', '-off'));
      $(this).removeClass('active');
    });
    var onImg = $(this).find('.nav__number img');
    onImg.attr('src', onImg.attr('src').replace('-off', '-on'));
    $(this).addClass('active');
    $(this).removeClass('hover-opa');
    $('.js-contents').removeClass('active').hide();
    $('.js-contents[data-tab="' + tabId + '"]').fadeIn(300).addClass('active');
       //非表示を表示に変更された時のslick発火用
       $('.js-product-slide').slick('setPosition');
  });

});
